<template>
<!--tabbar-->
    <div style="overflow-y: scroll;height: 100vh;">
      <van-pull-refresh
        v-model="isLoading"
        @refresh="onRefresh"
        :disabled="loading"
      >
        <van-list
          v-if="!nodata"
          v-model="loading"
          :finished="finished"
          finished-text="没有更多数据了"
          @load="onLoad"
        >
          <van-cell-group
            v-for="(item, index) in list"
            :key="index">
            <van-cell :border="false">
              <template #title>
                <span class="item-time">{{item.loadingTime | timeFormat}}</span>
              </template>
              <template #default>
                <p class="item-type">
                  <span class="dot"></span> {{item.status | statusToText}}
                </p>
              </template>
            </van-cell>
            <van-cell :border="false" class="item-no" :title="'派车单号：'+item.num"/>
            <van-cell :border="false" class="item-bd">
              <template #title>
                <div class="custom-title">{{item.shipper_name}}</div>
              </template>
              <template #icon>
                <div>
                  <span class="fa"></span>
                </div>
              </template>
              <template #label>
                <div class="custom-default">
                  <span>{{item.shipper_alias}}</span>
                  <span>{{item.begin_date | dataFormat}}</span>
                </div>
              </template>
            </van-cell>
            <van-cell :border="false" class="item-bd">
              <template #title>
                <div class="custom-title">{{item.consignee_name}}</div>
              </template>
              <template #icon>
                <span class="shou"></span>
              </template>
              <template #label>
                <div class="custom-default">
                  <span>{{item.consignee_alias}}</span>
                  <span>{{item.begin_date | dataFormat}}</span>
                </div>
              </template>
            </van-cell>
            <van-cell :border="false" class="item-bd" title="">
              <template #label>
                <div class="item-info">
                  <van-row>
                    <van-col span="15">
                      <span>车牌号：</span><span>{{item.license_plate}}</span>
                    </van-col>
                    <van-col span="9" class="right">
                      <span>司机：</span><span>{{item.driver_name}}</span>
                    </van-col>
                    <van-col span="24">
                      <span>手机号：</span><span>{{item.driver_tel}}</span>
                    </van-col>
                    <van-col span="24">
                      <span>货品名称：</span><span>{{item.pname}}</span>
                    </van-col>
                  </van-row>
                </div>
              </template>
            </van-cell>
            <van-cell :border="false" class="item-ft" title="">
              <template #label>
                <div class="btn-box-2">
                  <router-link tag="span" :to="{ path: '/SendcarsDetail/'+item.id }">派车单详情</router-link>
                </div>
              </template>
            </van-cell>
          </van-cell-group>
        </van-list>
        <van-empty v-else
          class="custom-image"
          :image="require('../../styles/img/nodata.png')"
        />
      </van-pull-refresh>
    </div>
</template>

<script>
export default {
  name: "InvoiceDetail",
  props: ['channel'],
  data() {
    return {
      list: [],
      nodata: false, // 是否有数据
      loading: false, // 是否上拉加载
      finished: false, // 上拉加载是否结束即加载全部数据
      isLoading: false, // 是否下拉刷新
      currentPage: 0,
      showCount: 10, //每页个数
      status: '',
      activeId: '',
      begin_date: '',
      end_date: '',
      licensePlate: ''
    }
  },
  created () {
    this.bus.$off()
    // 切换标签的对应id
    this.bus.$on('sendcarsOrderTabsId', (data) => {
      const { sendcarsOrderTabsId } = data
      this.activeId = sendcarsOrderTabsId
      if (sendcarsOrderTabsId !== this.activeId) {
        return
      }
      this.nodata = false;
      this.finished = false;
      this.currentPage = 1;
      this.list = [];
      this.getData();
    })
    // 获取搜索内容
    this.bus.$on('searchObj', (data) => {
      const { begin_date,end_date,licensePlate } = data
      this.begin_date = begin_date
      this.end_date = end_date
      this.licensePlate = licensePlate
      this.nodata = false;
      this.finished = false;
      this.currentPage = 1;
      this.list = [];
      this.getData();
    })
  },
  methods: {
    // 请求数据
    getData () {
      let status = this.activeId=='-1'?'':this.activeId;
      // this.$toast.loading({
      //   message: '加载中...',
      //   forbidClick: true,
      // });
      this.loading = true;
      this.isLoading = false;
      this.finished = false;
      let data = {
        status: status,  // 发货单状态 0:未开始 1:已接单  2:运输中 3:已到达 4:已签收  5:已取消
        currentPage: this.currentPage, // 当前页数
        showCount: this.showCount,    //显示个数
        begin_date:this.begin_date,
        end_date:this.end_date,
        licensePlate:this.licensePlate
      };
      // if(this.isLoading === true){
      //   this.loading = false
      // }
      this.$api.apis.getTrafficDispatchOrderFromSupply(data).then(res => {
        this.loading = false
        if(res.flag !== '200') {
          this.nodata = true
          return false
        }
        this.totalResult = res.rsObj.page.totalResult
        res.rsObj.page.totalResult > 0 ? (this.nodata = false) : (this.nodata = true)
        this.list = this.list.concat(res.rsObj.dispatchOrderList)
        if (this.list.length >= this.totalResult && this.list.length !== 0) {
        	this.finished = true;
        }
        // if(res&&res.rsObj&&res.rsObj.dispatchOrderList&&res.rsObj.dispatchOrderList.length>0){
        //   this.currentPage += 1;
        //   this.list = this.list.concat(res.rsObj.dispatchOrderList)
        //   // 加载状态结束
        //   this.loading = false
        //   if (!res.rsObj||res.rsObj.dispatchOrderList.length === 0||res.rsObj.dispatchOrderList.length<this.showCount ) {
        //     this.finished = true
        //   }
        // }else{
        //   this.finished = true
        //   this.loading = false
        //   this.nodata = false
        // }
        // this.isLoading = false
        // this.$toast.clear()
      });
    },
    // 下拉刷新
    onRefresh () {
        this.currentPage = 1;
        this.nodata = false;
        this.finished = false;
        this.list = [];
        this.getData();
      // this.$toast.success('刷新成功')
    },
    onLoad() {
      this.currentPage++
      this.getData();
    },
  },
  filters: {
    statusToText : (value) => {
      let result = "";
      switch(parseInt(value)){
        case 0:
          result = '未开始';
          break;
        case 1:
          result = '已接单';
          break;
        case 2:
          result = '运输中';
          break;
        case 3:
          result = '已到达';
          break;
        case 4:
          result = '已签收';
          break;
        case 5:
          result = '已取消';
          break;
        case 10:
          result = '已完成';
          break;
        default :
          result = ''
      }
      return result;
    },
    dataFormat : (value) => {
        if(!value) return ''
      let date = new Date(new Date(value.replace(/-/g, '/').replace(/T/g, ' ').substr(0, value.indexOf('.'))).getTime() + 3600 * 1000 * 8)
      let result = "";
      let y = date.getFullYear();
      let m = date.getMonth() + 1;
      let d = date.getDate();
      return result = `${y}-${m < 10 ? "0" + m : m}-${d < 10 ? "0" + d : d}`;
    },
    timeFormat : (value) => {
      if(!value) return ''
      let date = new Date(new Date(value.replace(/-/g, '/').replace(/T/g, ' ').substr(0, value.indexOf('.'))).getTime() + 3600 * 1000 * 8)
      let y = date.getFullYear();
      let m = date.getMonth() + 1;
      let d = date.getDate();
      let h = date.getHours();
      let min = date.getMinutes();
      let s = date.getSeconds();
      let result = "";
      return result = `${y}-${m < 10 ? "0" + m : m}-${d < 10 ? "0" + d : d} ${
          h < 10 ? "0" + h : h
          }:${min < 10 ? "0" + min : min}:${s < 10 ? "0" + s : s}`;
    }
  },
  watch: {}
};
</script>
<style lang="less">
  @import '../../styles/order.less';
</style>



// WEBPACK FOOTER //
// src/components/List/SendcarsList.vue